import { render } from "./AverageDeliveryTimeChart.vue?vue&type=template&id=8e253748&ts=true"
import script from "./AverageDeliveryTimeChart.vue?vue&type=script&lang=ts"
export * from "./AverageDeliveryTimeChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__